import * as Cookies from '../modules/helpers/cookies.js';

let modals = document.getElementsByClassName('modal');
let buttonTriggers = document.querySelectorAll('[data-trigger]');

for(let i = 0, length1 = modals.length; i < length1; i++){
    let elem        = modals[i];
    let type        = elem.getAttribute('data-modal-type');

    if(type == "signup"){
        doSignupModal( elem );
    }

     elem.onclick = function(e){
        if(e.target.classList.contains('modal')){
            hideModal( elem );
        }
     }
}

for(let j = 0, length1 = buttonTriggers.length; j < length1; j++){
    buttonTriggers[j].onclick = function(e){
        let trigger = this.getAttribute('data-trigger');
        let target = document.querySelector('[data-modal-type="'+trigger+'"]');
        if(target){
            e.preventDefault();

            showModal( target );
            closeModalWatcher( target );
        }
    }
}

function doSignupModal( elem ){
    let sessions = window.sessionStorage;

    if(sessions.length === 0){
         sessions.setItem('visits', 1);
         sessions.setItem('visits_destination', window.location.pathname);
    }
    else{
        let lastPage = sessions.getItem('visits_destination')
        let lastVisit = sessions.getItem('visits');

        if(window.location.pathname === lastPage){
            // console.log('Do stuff if your on the same page...');
        }
        else{
            sessions.setItem('visits', parseInt(lastVisit)+1);

            if(sessions.getItem('visits') === "2"){
                showModal( elem );
                closeModalWatcher( elem );
            }
        }

        sessions.setItem('visits_destination', window.location.pathname);
    }
}

/* ------------
Modal Helpers
------------ */
function showModal( elem ){
    elem.setAttribute('aria-hidden', 'false');
}

function hideModal( elem ){
     elem.setAttribute('aria-hidden', 'true');
}

function closeModalWatcher( elem ){
    elem.querySelector('.modal-close').onclick = function(){
        hideModal( elem );
    }
}
